const datePickerLocalization = {
  modalHeading: 'Choose a date',
  closeLabel: 'Close window',
  buttonLabel: 'Choose date',
  selectedDateMessage: 'Selected date is',
  dateOutOfMinBound: (minDate: string) => `Date must be on or after ${minDate}`,
  dateOutOfMaxBound: (maxDate: string) => `Date must be on or before ${maxDate}`,
}

export default datePickerLocalization
